import { render, staticRenderFns } from "./memory.vue?vue&type=template&id=4c47ae3c&scoped=true&"
import script from "./memory.vue?vue&type=script&lang=js&"
export * from "./memory.vue?vue&type=script&lang=js&"
import style0 from "./memory.vue?vue&type=style&index=0&id=4c47ae3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c47ae3c",
  null
  
)

export default component.exports